export default __webpack_public_path__ + "static/media/layout_dark_human.9ccfd7fd.svg";